// export const apiKey = "http://localhost:5001";
// export const apiKey = "https://admin.amancredits.com/api";
export const apiKey = "https://newcontracts.amancredits.com/api";
